import React, { useState } from 'react';
import { Button } from '../../components/ui/button';

const tournaments = [
  {
    value: '5826',
    label: 'Schnupperkurs SK5 [5826] / (03.08.24)',
  },
  {
    value: '5839',
    label: 'Kurzspielkurs KSK 5 [5839] / (03.08.24)',
  },
  {
    value: '5892',
    label: 'Kinderschnupperkurs August [5892] / (03.08.24)',
  },
  {
    value: '5930',
    label: 'BWGV-Liga AK 30 Herren 2. Liga Gruppe D [5930] / (03.08.24)',
  },
  {
    value: '5931',
    label: 'BWGV-Liga AK 30 Damen 1. Liga Gruppe B [5931] / (03.08.24)',
  },
];

const PlayersCopyLocalPage: React.FC = () => {
  const [selectedTournament, setSelectedTournament] = useState<string | null>(
    null,
  );

  const handleSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSelectedTournament(event.target.value);
  };

  const handleButtonClick = () => {
    console.log('Selected Tournament:', selectedTournament);
  };

  return (
    <div className="bg-white mx-5 grid gap-4 p-4 border rounded-md leading-6">
      <div className="text-lg mb-4 border-b pb-2 font-medium">
        Spieler dieses Turniers kopieren
      </div>
      <div className="font-medium">
        🏆 BWGV AK 30 Herren - 2. Liga Gruppe D <br />
        📍 V-Ort: Schönbuch <br />
        📅 Datum: 03.08-03.08.24 36 <br />
        👥 Spieler bereit zur Übertragung
      </div>

      <div className="border flex gap-4 leading-6 rounded-md bg-yellow-50 p-2 border-yellow-300">
        <div className="text-xl flex items-center justify-center rounded-full bg-yellow-300 w-7 h-7">
          !
        </div>
        <div>
          <b>Bitte wählen Sie das Turnier, in das kopiert werden soll 🏆️</b>
        </div>
      </div>

      <div className="grid gap-1 border p-4 rounded-md">
        {tournaments.map((tournament) => (
          <div className="flex gap-4" key={tournament.value}>
            <div>
              <input
                type="radio"
                name="tournament"
                id={`tournament-${tournament.value}`}
                value={tournament.value}
                onChange={handleSelectionChange}
              />
            </div>
            <label
              className="font-medium"
              htmlFor={`tournament-${tournament.value}`}
            >
              {tournament.label}
            </label>
          </div>
        ))}
      </div>
      <Button className="w-52" onClick={handleButtonClick}>
        Dieses Turnier auswählen
      </Button>
    </div>
  );
};

export default PlayersCopyLocalPage;
